// Fachada do domínio Storage — métodos da instância (ver core.ts).
import { storageService } from './core';

export const uploadAvatar      = storageService.uploadAvatar;
export const setProfileAvatar  = storageService.setProfileAvatar;
export const uploadEmpresaLogo = storageService.uploadEmpresaLogo;
export const setEmpresaLogo    = storageService.setEmpresaLogo;

export { MAX_AVATAR_BYTES } from '@modules/storage';
export { AVATAR_BUCKET } from '@infra/supabase/repositories/SupabaseStorageRepository';
